import { useEffect, useRef, useState } from "react";

/**
 * Tracks a container's clientWidth/clientHeight via ResizeObserver so an
 * SVG viewport can auto-fit to whatever frame the parent provides.
 * Returns [ref, size] — attach `ref` to the container element.
 *
 * Extracted from FloorPlan2D.jsx (V2.0.18) for testability + reuse.
 */
export default function useContainerSize(defaultSize = { w: 1100, h: 700 }) {
  const containerRef = useRef(null);
  const [containerSize, setContainerSize] = useState(defaultSize);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const cr = entry.contentRect;
        if (cr.width > 0 && cr.height > 0) {
          setContainerSize({ w: cr.width, h: cr.height });
        }
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return [containerRef, containerSize];
}
